import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { B2cWidgetComponent } from '../../components/b2c/b2c-widget.component';
import { B2cConfirmationComponent } from '../../components/b2c/b2c-confirmation.component';

const routes: Routes = [
  { path: '', redirectTo: 'widget', pathMatch: 'full' },
  {
    path: 'widget',
    component: B2cWidgetComponent,
    data: { title: 'B2C' },
  },
  {
    path: 'confirmation/:id',
    component: B2cConfirmationComponent,
    data: { title: 'B2C Confirmation' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class B2cRoutingModule {}
